<script>
  import { fade } from "svelte/transition";
  import { _ } from "@services/i18n";
  import { textMode, voiceMode } from "@stores/global";
  import { FADE_DURATION } from "../consts";

  export let notification = false;
  export let text = $_("components.tooltip.text", {
    default: "Hold to speak"
  });
</script>

<style>
  .tooltip {
    background: var(--primary-color);
    border-radius: 4px;
    color: var(--on-primary-color);
    display: inline-block;
    font-size: 1.75rem;
    left: 50%;
    letter-spacing: 0;
    line-height: 1.2;
    max-width: 50rem;
    padding: 1.5rem 2.25rem;
    position: absolute;
    text-align: center;
    text-shadow: none;
    text-transform: none;
    transform: translateX(-50%);
    width: fit-content;
    z-index: 3;
  }

  .textMode {
    bottom: 10rem;
  }

  .voiceMode {
    bottom: 15rem;
  }

  .arrow::after {
    background: var(--primary-color);
    bottom: -1.2rem;
    content: "";
    height: 2.5rem;
    left: 50%;
    position: absolute;
    transform: translateX(-50%) rotate(45deg);
    width: 2.5rem;
  }
</style>

<div
  class="tooltip"
  class:arrow={!notification}
  class:notification
  class:textMode={$textMode}
  class:voiceMode={$voiceMode}
  transition:fade={{duration: FADE_DURATION}}
>{text}</div>
